//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionNavigate from "../../transitions/Navigate.vue";
import SearchLoader from "../loader/Loader.vue";
import Item from "./Item.vue";
import { format } from "date-fns";

export default {
  name: "BlueResults",
  components: { TransitionNavigate, SearchLoader, Item },
  props: [],
  data() {
    return {};
  },
  computed: {
    results() {
      return this.$store.getters.results.itemResults;
    },
    reloading() {
      if (this.options.transitionOnReload) return this.$store.getters.reloading;
      else return false
    },
  },
  methods: {
    formatDate(date, formatPattern) {
      return format(new Date(date), formatPattern);
    },
    getElTop() {
      let elem = this.$root.$el;
      let distance = 0;
      do {
        distance += elem.offsetTop;
        elem = elem.offsetParent;
      } while (elem);
      distance = distance < 0 ? 0 : distance;
      return distance;
    },
    scrollToTop() {
      if (this.options.scrollOnReload) window.scrollTo({ top: this.getElTop(), behavior: "smooth" });
    },
  },
  watch: {
    reloading() {
      this.scrollToTop();
    },
  },
};
